import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { MergedCompetency } from 'lib/competencies/getMergedCompetencies';
import { ModalButtonWithForm } from 'components/common';
import { ProfileCompetenciesEndorsementsForm } from '.';

import type { FormValues } from 'informed';

interface Props {
  competency: MergedCompetency;
  targetUserId: number;
  updateCompetencies: () => Promise<void>;
}

const ProfileCompetenciesEndorsementsEndorse = ({
  competency,
  targetUserId,
  updateCompetencies
}: Props) => {
  const { dispatch } = useDispatch();
  const { messages, theme, user } = useReduxState();

  const handleSubmit = async (values: FormValues) => {
    try {
      await api.post('/admin/competency-endorsements/', {
        comment: values.comment || null,
        CompetencyId: competency.id,
        CompetencyLevelId: competency.levels
          ? competency.highestLevel.id
          : null,
        UserId: targetUserId
      });
      dispatch(
        actions.addNotice({
          text: messages.competenciesEndorsementAddedSuccessfully,
          type: 'success'
        })
      );
      await updateCompetencies();
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return (
    <div>
      <ModalButtonWithForm
        buttonCategory="success"
        buttonIcon={['far', 'thumbs-up']}
        buttonIsDropDown={true}
        buttonText={messages.competenciesEndorseCompetency}
        buttonSize="header"
        modalActionText={messages.commonConfirm}
        modalTitle={messages.competenciesEndorseCompetency}
        modalWidth="medium"
        onSubmit={handleSubmit}
      >
        {() => <ProfileCompetenciesEndorsementsForm competency={competency} />}
      </ModalButtonWithForm>

      <style jsx>{`
        .label {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .description {
          margin-top: 5px;
          margin-bottom: 15px;
          color: ${theme.textColorLighter};
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
        }
      `}</style>
    </div>
  );
};

export default ProfileCompetenciesEndorsementsEndorse;
